// src/i18n/compte.js
// La langue de l'interface, recopiée sur le COMPTE (client titulaire ou membre) : c'est elle qui
// décide de la langue des e-mails, et des SMS et appels des contacts d'alerte sans langue.
// Rien pour l'admin, qui reste en français. Sans session : rien (la langue est enregistrée à la
// connexion suivante).
import apiService from '@/services/api.service';
import authService from '@/services/auth.service';
import { langueCourante } from './index';

export function enregistrerLangueCompte(code = langueCourante()) {
  const user = authService.getUser && authService.getUser();
  if (!user || user.role === 'admin' || !authService.getToken()) return Promise.resolve();
  return apiService.definirLangue(code).catch(() => { /* sans conséquence : réessayé à la connexion */ });
}
